module.exports = __webpack_public_path__ + "img/num_23.84f804fa.png";